import type { InternalCompanySchema } from "@vellum/vellum-api";

import { getCompanyContactsUrl } from "@/config";

export function CompanyContactsSection({
  company,
}: {
  company: InternalCompanySchema;
}) {
  return (
    <div className="border-b border-gray-200 bg-white px-4 py-3">
      <div className="flex items-center justify-between gap-3">
        <div>
          <h2 className="text-sm font-semibold">Luna Company contacts</h2>
        </div>
        <a
          href={getCompanyContactsUrl(company.id)}
          target="_blank"
          className="group inline-flex items-center gap-1.5 whitespace-nowrap text-sm text-gray-600 transition-colors hover:text-blue-600"
        >
          <span
            className="iconoir-open-new-window text-base"
            aria-hidden="true"
          />
          <span className="underline">View contacts in Luna</span>
          <span
            className="iconoir-arrow-right text-base text-gray-300 transition-all duration-200 group-hover:translate-x-0.5 group-hover:text-blue-600"
            aria-hidden="true"
          />
        </a>
      </div>
    </div>
  );
}
